import React, {useState} from 'react';
import {AutoProjectStatusTabs} from '../../AutoProjectStatusTabs/Config/AutoProjectStatusTabs.config';
import {TabPanelView} from '../../TabPanel';
import {CardContent, Body1} from '../../../ui-library';
import useAutoProjectTrainingStatus from '../Controller/AutoProjectTrainingStatusTab.controller';
import {
    AccuracyBox,
    ClassesBox, CardsBox,
    StyledCard,
    IconBox,
    StyledInsightsIcon,
    InTrainClassChip, SpaceBetweenBox
} from '../Style/AutoProjectTrainingStatusTab.style';
import {IPropsView} from '../Config/AutoProjectTrainingStatusTab.types';
import {AutoTrainingStatusDataView} from '../../AutoTrainingStatusData/index';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';


const AutoProjectTrainingStatusTabView = ({value, autoProjectState, projectIdInit, setState}: IPropsView) => {
    const [trainings, setTrainings] = useState({});

    useAutoProjectTrainingStatus({projectIdInit, value, setTrainings, setState});

    return (
        <>   {Object.keys(trainings).length !== 0 && (
            <TabPanelView value={value} index={AutoProjectStatusTabs.TrainingStatus}>
                <CardsBox>
                    {Object.entries(trainings).map(([feature, versions]) =>
                        (versions as any).map((version) => (
                            <StyledCard key={version.id}>
                                <CardContent>
                                    <AutoTrainingStatusDataView
                                        feature={feature}
                                        version={version}/>
                                    <SpaceBetweenBox>
                                        {autoProjectState.classes && (
                                            <ClassesBox>
                                                <Body1>{_SYSTEM_TITLES.autoTrainingStatusPageClassesTitle}</Body1>
                                                {version.classes.map((tagId, index) => {
                                                    const classData = autoProjectState.classes.find((cur) => cur.tag_id === tagId);


                                                    return (
                                                        <InTrainClassChip
                                                            key={index}
                                                            label={classData && classData.tag_name}
                                                        />
                                                    );
                                                })}
                                            </ClassesBox>
                                        )}
                                        <AccuracyBox>
                                            {version.accuracy && <IconBox>
                                                <StyledInsightsIcon/>
                                                <Body1> Accuracy {version.accuracy}% </Body1>
                                            </IconBox>}
                                        </AccuracyBox>
                                    </SpaceBetweenBox>
                                </CardContent>
                            </StyledCard>
                        ))
                    )}
                </CardsBox>
            </TabPanelView>
        )}
        </>
    );
};

export default AutoProjectTrainingStatusTabView;
